import React, { useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import Modal from "../../Modal";

const useStyles = makeStyles(theme => ({
  section: {
    display: "flex",
    marginTop: theme.spacing(3)
  }
}));

export default function CreateCalendar(props) {
  const classes = useStyles();
  const { open, onOpenChange, onSubmit } = props;

  const [calendarData, setCalendarData] = useState({
    name: "",
    description: ""
  });

  const handleCalendarDataChange = field => event => {
    setCalendarData({
      ...calendarData,
      [field]: event && event.target ? event.target.value : event
    });
  };

  return (
    <Modal
      scrollable
      maxWidth="sm"
      fullWidth
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          Create New Calendar
        </Typography>
      }
      dialogContent={
        <Box display="flex" flexDirection="column">
          <Box className={classes.section}>
            <TextField
              placeholder="Name"
              margin="normal"
              variant="filled"
              fullWidth
              onChange={handleCalendarDataChange("name")}
              hiddenLabel
            />
          </Box>
          <Box className={classes.section}>
            <TextField
              placeholder="Add Description"
              rows="3"
              margin="normal"
              variant="filled"
              fullWidth
              multiline
              InputProps={{
                disableUnderline: true
              }}
              onChange={handleCalendarDataChange("description")}
              hiddenLabel
            />
          </Box>
        </Box>
      }
      dialogActions={
        <>
          <Button color="primary" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onSubmit(calendarData)}
          >
            Create Calendar
          </Button>
        </>
      }
      open={open}
      onClose={() => onOpenChange(false)}
      showCloseIcon
    />
  );
}

CreateCalendar.propTypes = {
  /**
   * True if the create calendar modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the create calendar modal is open or closed
   */
  onOpenChange: PropTypes.func,
  /**
   * Called when the save button is pressed to save the newly created calendar
   */
  onSubmit: PropTypes.func
};
